import { SvgIcon, Text } from '@cinch-labs/design-system'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import { createHelpAndSupportTrackingEvent } from '../tracking'
import { readFromEnv } from '@cinch-nx/environments'
import styles from './help-and-support-cta.module.css'

const HelpAndSupportCta = () => {
  const helpAndSupportURL = readFromEnv('HELP_AND_SUPPORT_URL')

  const { trackEvent } = useAnalytics()

  return (
    <a
      className={styles.container}
      href={helpAndSupportURL}
      onClick={() => trackEvent(createHelpAndSupportTrackingEvent())}
      target="_blank"
    >
      <Text
        lineHeight="display"
        fontSizeFixed="xxl"
        fontWeight="semibold"
        element="span"
      >
        Got a question?
      </Text>
      <Text fontSizeFixed="xs" fontWeight="medium" element="span">
        See our FAQs and get in touch
      </Text>
      <Text
        lineHeight="display"
        fontSizeFixed="s"
        element="span"
        className={styles.linkLabel}
      >
        Visit our help centre{' '}
        <SvgIcon name="external-link" className={styles.linkIcon} />
      </Text>
    </a>
  )
}

export default HelpAndSupportCta
